<template>
  <div
    v-if="hide_menu"
    class="absolute top-[15%] z-[60] bg-blues p-2 lg:hidden rounded-r-xl cursor-pointer h-[40px]"
    @click="toggleMenu"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20"
      height="20"
      viewBox="0 0 50 50"
      fill="#fff"
    >
      <path
        d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
      ></path>
    </svg>
  </div>

  <div
    class="lg:flex fixed w-[95%] bg-white lg:w-[35%] lg:left-0 xl:w-[30%] 2xl:w-[25%] lg:relative z-30 mt-10 lg:m-10 rounded-3xl heightfix"
    :class="{ hidden: !isMobile }"
    style="box-shadow: 0px 2px 30px 0px #01b0f926"
  >
    <div
      @click="toggleSidebar"
      class="absolute top-2 right-[2px] z-30 block lg:hidden bg-gray-200 rounded-full p-1 cursor-pointer"
    >
      <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
    </div>
    <div
      ref="navMenu"
      @scroll="saveScroll"
      class="flex flex-col gap-5 relative w-full overflow-y-auto p-10 h-full"
    >
      <router-link
        :to="{ name: 'InstructorStudents' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'InstructorStudents',
          'hover:bg-gray-100': $route.name != 'InstructorStudents',
        }"
      >
        <img
          src="@/assets/newd/icons/Grid.png"
          v-if="$route.name == 'InstructorStudents'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Grid-1.png"
          v-if="$route.name != 'InstructorStudents'"
          alt=""
        />
        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'InstructorStudents',
            'text-[#333333]': $route.name != 'InstructorStudents',
          }"
        >
          Students
        </p>
      </router-link>

      <router-link
        :to="{ name: 'AddStudents' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl hidden"
        :class="{
          'bg-[#0085DB]': $route.name == 'AddStudents',
          'hover:bg-gray-100': $route.name != 'AddStudents',
        }"
      >
        <img
          src="@/assets/newd/icons/Grid.png"
          v-if="$route.name == 'AddStudents'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Grid-1.png"
          v-if="$route.name != 'AddStudents'"
          alt=""
        />
        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'AddStudents',
            'text-[#333333]': $route.name != 'AddStudents',
          }"
        >
          Add Students
        </p>
      </router-link>

      <router-link
        v-if="checkinTheList('Messages')"
        :to="{ name: 'InstructorNewMessages' }"
        @click="handleNavClick"
        class="flex items-center justify-between gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'InstructorNewMessages',
          'hover:bg-gray-100': $route.name != 'InstructorNewMessages',
        }"
      >
        <div class="flex items-center gap-5">
          <img
            src="@/assets/newd/icons/mdi-light_forum-1.png"
            v-if="$route.name == 'InstructorNewMessages'"
            alt=""
          />
          <img
            src="@/assets/newd/icons/mdi-light_forum.png"
            v-if="$route.name != 'InstructorNewMessages'"
            alt=""
          />

          <p
            class="font-bold text-xs"
            :class="{
              'text-white': $route.name == 'InstructorNewMessages',
              'text-[#333333]': $route.name != 'InstructorNewMessages',
            }"
          >
            Messages
          </p>
        </div>
        <div
          v-if="this.user_count > 0"
          class="p-1 text-xs w-9 h-9 rounded-full border flex justify-center items-center bg-white"
        >
          {{ this.user_count }}
        </div>
      </router-link>

      <router-link
        v-if="checkinTheList('Assignments')"
        :to="{ name: 'InstructorAssignments' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': assignMentActive,
          'hover:bg-gray-100': !assignMentActive,
        }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="assignMentActive"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="!assignMentActive"
          alt=""
        />
        <p
          class="font-bold text-xs"
          :class="{
            'text-white': assignMentActive,
            'text-[#333333]': !assignMentActive,
          }"
        >
          Assignments
        </p>
      </router-link>

      <router-link
        v-if="checkinTheList('Homework')"
        :to="{ name: 'HomeWorks' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl hidden"
        :class="{
          'bg-[#0085DB]': homeWorkActive,
          'hover:bg-gray-100': !homeWorkActive,
        }"
      >
        <img
          src="@/assets/newd/icons/Calendar2Week-1.png"
          v-if="homeWorkActive"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Calendar2Week.png"
          v-if="!homeWorkActive"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': homeWorkActive,
            'text-[#333333]': !homeWorkActive,
          }"
        >
          Homework
        </p>
      </router-link>

      <router-link
        v-if="checkinTheList('Messages')"
        :to="{ name: 'InstructorNewForums' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'InstructorNewForums',
          'hover:bg-gray-100': $route.name != 'InstructorNewForums',
        }"
      >
        <img
          src="@/assets/newd/icons/Archive-1.png"
          v-if="$route.name == 'InstructorNewForums'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Archive.png"
          v-if="$route.name != 'InstructorNewForums'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'InstructorNewForums',
            'text-[#333333]': $route.name != 'InstructorNewForums',
          }"
        >
          Forums
        </p>
      </router-link>

      <router-link
        :to="{ name: 'InstructorClasses' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'InstructorClasses',
          'hover:bg-gray-100': $route.name != 'InstructorClasses',
        }"
      >
        <img
          src="@/assets/newd/icons/Calendar2Week-1.png"
          v-if="$route.name == 'InstructorClasses'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Calendar2Week.png"
          v-if="$route.name != 'InstructorClasses'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'InstructorClasses',
            'text-[#333333]': $route.name != 'InstructorClasses',
          }"
        >
          Live Classes
        </p>
      </router-link>

      <router-link
        v-if="checkinTheList('Assessment')"
        :to="{ name: 'InstructorQuizs' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': assessmentActive,
          'hover:bg-gray-100': !assessmentActive,
        }"
      >
        <img
          src="@/assets/newd/icons/BarChartLine-1.png"
          v-if="assessmentActive"
          alt=""
        />
        <img
          src="@/assets/newd/icons/BarChartLine.png"
          v-if="!assessmentActive"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': assessmentActive,
            'text-[#333333]': !assessmentActive,
          }"
        >
          Assessment
        </p>
      </router-link>

      <router-link
        v-if="checkinTheList('Projects')"
        :to="{ name: 'InstructorBlogs' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'InstructorBlogs',
          'hover:bg-gray-100': $route.name != 'InstructorBlogs',
        }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'InstructorBlogs'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'InstructorBlogs'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'InstructorBlogs',
            'text-[#333333]': $route.name != 'InstructorBlogs',
          }"
        >
          Projects
        </p>
      </router-link>

      <router-link
        :to="{ name: 'CourseComplete' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'CourseComplete',
          'hover:bg-gray-100': $route.name != 'CourseComplete',
        }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'CourseComplete'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'CourseComplete'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'CourseComplete',
            'text-[#333333]': $route.name != 'CourseComplete',
          }"
        >
          Grading
        </p>
      </router-link>

      <router-link
        :to="{ name: 'PollStudents' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'PollStudents',
          'hover:bg-gray-100': $route.name != 'PollStudents',
        }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'PollStudents'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'PollStudents'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'PollStudents',
            'text-[#333333]': $route.name != 'PollStudents',
          }"
        >
          Lesson Polls
        </p>
      </router-link>

      <router-link
        :to="{ name: 'InstructorAllStudents' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl hidden"
        :class="{
          'bg-[#0085DB]': $route.name == 'InstructorAllStudents',
          'hover:bg-gray-100': $route.name != 'InstructorAllStudents',
        }"
      >
        <img
          src="@/assets/newd/icons/Calendar2Week-1.png"
          v-if="$route.name == 'InstructorAllStudents'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Calendar2Week.png"
          v-if="$route.name != 'InstructorAllStudents'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'InstructorAllStudents',
            'text-[#333333]': $route.name != 'InstructorAllStudents',
          }"
        >
          All Student
        </p>
      </router-link>

      <router-link
        :to="{ name: 'GradeBook' }"
        @click="handleNavClick"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'GradeBook',
          'hover:bg-gray-100': $route.name != 'GradeBook',
        }"
      >
        <img
          src="@/assets/newd/icons/Calendar2Week-1.png"
          v-if="$route.name == 'GradeBook'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Calendar2Week.png"
          v-if="$route.name != 'GradeBook'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'GradeBook',
            'text-[#333333]': $route.name != 'GradeBook',
          }"
        >
          Grade Book
        </p>
      </router-link>
      <!-- <router-link v-if="this.userInfo.user.permission == 'super_admin' || this.userInfo.user.permission == 'hod' || this.userInfo.user.permission == 'co-ordinator'"
        :to="{ name: 'COPOPSO' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'COPOPSO' }"
      >
        <img
          src="@/assets/newd/icons/Calendar2Week-1.png"
          v-if="$route.name == 'COPOPSO'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Calendar2Week.png"
          v-if="$route.name != 'COPOPSO'"
          alt=""
        />

        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'COPOPSO',
            'text-[#333333]': $route.name != 'COPOPSO',
          }"
        >
          CO PO PSO
        </p>
      </router-link> -->

      <!-- <router-link
        :to="{ name: 'SkillGapAnalysis' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'SkillGapAnalysis' }"
      >

        <img
          src="@/assets/newd/icons/BarChartLine-1.png"
          v-if="$route.name == 'SkillGapAnalysis'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/BarChartLine.png"
          v-if="$route.name != 'SkillGapAnalysis'"
          alt=""
        />

        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'SkillGapAnalysis',
            'text-[#333333]': $route.name != 'SkillGapAnalysis',
          }"
        >
          Skill Gap Analysis
        </p>
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import axios from "axios";

export default {
  computed: {
    ...mapGetters(["isAuthenticated", "userInfo", "permissionList"]),
    ...mapState(["navScrollPosition"]),

    savedScrollPosition() {
      if (
        this.navScrollPosition !== undefined &&
        this.navScrollPosition !== null
      ) {
        return this.navScrollPosition;
      }
      const stored = localStorage.getItem("instructorNavScrollPosition");
      return stored ? parseInt(stored, 10) : 0;
    },

    assignMentActive() {
      return (
        this.$route.name == "InstructorAssignments" ||
        this.$route.name == "InstructorAssignmentsSubmitted" ||
        this.$route.name == "SingleFeedback" ||
        this.$route.name == "OverallFeedback"
      );
    },
    homeWorkActive() {
      return (
        this.$route.name == "HomeWorks" ||
        this.$route.name == "AdminHomeworkDetail" ||
        this.$route.name == "HomeworkSingleFeedback" ||
        this.$route.name == "HomeworkOverallFeedback"
      );
    },
    assessmentActive() {
      return (
        this.$route.name == "InstructorQuizs" ||
        this.$route.name == "AssessmentOverallFeedback"
      );
    },
  },

  data() {
    return {
      isMobile: false,
      hide_menu: true,
      course_id: 0,
      user_count: 0,
      scrollRestoreInterval: null,
      lastRouteChange: 0,
    };
  },

  watch: {
    $route: {
      handler(to, from) {
        this.lastRouteChange = Date.now();

        this.$nextTick(() => {
          this.restoreScrollPosition();
        });

        setTimeout(() => {
          this.restoreScrollPosition();
        }, 100);

        setTimeout(() => {
          this.restoreScrollPosition();
        }, 300);
      },
      immediate: false,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.restoreScrollPosition();
    });

    setTimeout(() => {
      this.restoreScrollPosition();
    }, 100);

    this.startScrollRestoreInterval();

    const urlSegments = this.$route.path.split("/");
    this.course_id = urlSegments.find((segment) => /^\d+$/.test(segment));
    console.log("course_id:", this.course_id);
  },

  beforeUnmount() {
    console.log("SideNav unmounting - saving scroll");
    this.saveScroll();

    if (this.scrollRestoreInterval) {
      clearInterval(this.scrollRestoreInterval);
    }
  },

  methods: {
    ...mapMutations(["setNavScrollPosition"]),
    startScrollRestoreInterval() {
      if (this.scrollRestoreInterval) {
        clearInterval(this.scrollRestoreInterval);
      }

      this.scrollRestoreInterval = setInterval(() => {
        if (Date.now() - this.lastRouteChange < 2000) {
          const scrollPos = this.savedScrollPosition;
          if (this.$refs.navMenu && scrollPos > 0) {
            const currentScroll = this.$refs.navMenu.scrollTop;

            if (currentScroll === 0 && scrollPos > 0) {
              this.$refs.navMenu.scrollTop = scrollPos;
            }
          }
        }
      }, 500);
    },

    restoreScrollPosition() {
      const scrollPos = this.savedScrollPosition;

      if (this.$refs.navMenu && scrollPos > 0) {
        this.$refs.navMenu.scrollTop = scrollPos;

        this.$refs.navMenu.offsetHeight;

        this.$refs.navMenu.scrollTop = scrollPos;

        console.log(
          " Current scroll after restore:",
          this.$refs.navMenu.scrollTop
        );
      } else {
        console.log(
          "Cannot restore - navMenu ref:",
          !!this.$refs.navMenu,
          "scrollPosition:",
          scrollPos
        );
      }
    },

    saveScroll() {
      if (this.$refs.navMenu) {
        const currentScroll = this.$refs.navMenu.scrollTop;

        try {
          this.setNavScrollPosition(currentScroll);
          console.log(" Vuex - Scroll saved:", currentScroll);
        } catch (error) {
          console.error(" Vuex save failed:", error);
        }

        try {
          localStorage.setItem(
            "instructorNavScrollPosition",
            currentScroll.toString()
          );
          console.log("localStorage - Scroll saved:", currentScroll);
        } catch (error) {
          console.error(" localStorage save failed:", error);
        }
      }
    },

    handleNavClick() {
      this.saveScroll();
      this.lastRouteChange = Date.now();
    },

    checkinTheList(feature) {
      let check = this.permissionList.find((x) => x === feature);
      return check !== undefined;
    },

    toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },

    toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile;
    },

    async getstudentCount() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/message_count/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.user_count = resp.data.user_count;
          }
        });
    },
  },
};
</script>

<style scoped>
img {
  width: 20px;
  height: 20px;
}
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
